import React from 'react'

const RadioButton = ({
  children,
  onClick,
  isActive,
  textClassName = 'font-semibold text-sm text-primary-100',
  activeTextClassName = 'text-white font-bold',
  padding = 'py-[10px] px-[22px]',
}) => {
  return (
    <button
      type="button"
      className={`border-[1px] border-solid border-primary-100 bg-[#FDFDFD] rounded-[8px] transition-colors duration-200 ease ${padding} ${textClassName} ${isActive ? `!bg-primary-75 ${activeTextClassName}` : ''}`}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export default RadioButton
